import type { ValidationErrors } from '@frontend/utils/validation';
import { getSelectedLanguage } from '@frontend/translate';
import { TextInputFormGroup } from './processActivityFormGroupFields';

export function EmailAddressFormGroup<T extends { patient: { emailAddress: string | null } }>(
    props: Readonly<{
        data: T;
        errors: ValidationErrors;
        onChange: (data: Partial<T>, validateKeys?: string | string[] | undefined) => void;
    }>
) {
    const translate = getSelectedLanguage();

    return (
        <TextInputFormGroup
            fieldKey="patient.emailAddress"
            hasErrors={props.errors.has('patient.emailAddress')}
            isRequired={true}
            label={translate.patient.patientEmailAddress}
            onChange={async (value) => {
                props.onChange(
                    {
                        patient: {
                            ...props.data.patient,
                            emailAddress: value,
                        },
                    } as Partial<T>,
                    ['patient.emailAddress']
                );
            }}
            placeholder={translate.common.emailAddress}
        />
    );
}
